<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%" v-show="!dialogTableVisible">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">审核打卡管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>堆物堆料打卡列表</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div>
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="selectedMonth"
                    type="month"
                    placeholder="选择年月"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    @change="calcMonthWeeks"
                    style="width: 150px;"
                  >
                  </el-date-picker>

                  <!-- 周数选择器（补全最后一周跨月日期） -->
                  <el-select
                    v-model="selectedWeek"
                    placeholder="选择该月第几周"
                    @change="handleWeekSelect"
                    class="monthWeek"
                    style="width: 300px;"
                  >
                    <el-option
                      v-for="(week, index) in monthWeeks"
                      :key="index"
                      :label="`第${index+1}周（${week.start} 至 ${week.end}）`"
                      :value="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="建筑物名称">
                  <el-input
                    v-model="form.buildingName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属社区">
                  <el-select
                    v-model="form.pointLevelId"
                    filterable
                    placeholder="请选择">
                    <el-option
                      v-for="item in actionsOne"
                      :key="item.deptCode"
                      :label="item.text"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否打卡">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasRecordFlag"
                  >
                    <el-option
                      v-for="item in shenheList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否含人工审核">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.isManualAudit"
                  >
                    <el-option
                      v-for="item in shenheList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="人工审核">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.manualAuditState"
                  >
                    <el-option
                      v-for="item in rgshList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="智能识别">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.aiAuditState"
                  >
                    <el-option
                      v-for="item in znsbList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn">
              <div class="mr-40">建筑物总数：<span class="cl-primary">{{ shanghuCount.buildingCount }}</span>幢</div>
              <div class="mr-40">本周已打卡建筑物：<span class="cl-primary">{{ shanghuCount.reportBuildingCount }}</span>幢</div>
              <div class="mr-40">本周未打卡建筑物：<span class="cl-primary">{{ shanghuCount.notReportBuildingCount }}</span>幢</div>
            </div>
            <div class="right-btn">
              <el-button
                @click="dutyWordExp"
                icon="el-icon-download"
                class="search"
                >导出列表</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="540"
          >
            <template v-slot:createTime="{ scope }">
              <span>{{ scope.row.reportStartTime ? scope.row.reportStartTime.substring(0,10).replaceAll('-', '/') : '' }}-{{ scope.row.reportEndTime ? scope.row.reportEndTime.substring(0,10).replaceAll('-', '/') : '' }}</span>
            </template>
            <template v-slot:rangeHourTime="{ scope }">
              <span>{{ scope.row.adminAuditCount || 0 }}/{{ scope.row.communityAuditCount || 0 }}/{{ scope.row.recordCount || 0 }}</span>
            </template>
            <template v-slot:isManualAudit="{ scope }">
              <span>{{ scope.row.isManualAudit ? '是' : '否' }}</span>
            </template>
            <!-- 智能识别结果 -->
            <template v-slot:zhinshibie="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.recordList && scope.row.recordList" :key="index" :class="item.aiAuditState == '已通过' ? 'pass' : item.aiAuditState == '不通过' ? 'noPass' : 'warin'" >{{ item.aiAuditState }}</span>
            </template>
            <!-- 人工审核结果 -->
            <template v-slot:submitFlag="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.recordList && scope.row.recordList" :key="index" :class="(item.adminAuditState && item.adminAuditState != '待审核') ? (item.adminAuditState == '已通过' ? 'pass' : item.adminAuditState == '不通过' ? 'noPass' : 'warin') : (item.communityAuditState && item.communityAuditState != '待审核' ? (item.communityAuditState == '已通过' ? 'pass' : item.communityAuditState == '不通过' ? 'noPass' : 'warin') : 'warin')" >{{ (item.adminAuditState && item.adminAuditState != '待审核') ? item.adminAuditState : (item.communityAuditState && item.communityAuditState != '待审核' ? item.communityAuditState : '待审核') }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                v-if="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('APPROVAL')"
                @click="manualReview(scope.row)"
                style="font-size: 16px"
                type="text"
                >人工审核</el-button
              >
              <el-button
                @click="qusetionDetail(scope.row)"
                style="font-size: 16px"
                type="text"
                >详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detailForm
      v-if="dialogTableVisible"
      :item="currentItem"
      :dialogType="dialogType"
      @closeDialog="closeDetail"
    ></detailForm>
  </div>
</template>

<script>
import {
  exportReportInfo,
  recordPage,
  reportInfoCount
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import detailForm from "./detailForm.vue";
import {
  getCommcommunityAll,
} from "@/api/point.js";
export default {
  components: {
    detailForm,
    commonTable
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      currentItem: {},
      dialogVisible2: false,
      exportLoading: false,
      exportForm: {
        createTimeEnd: "",
        createTimeStart: "",
        searchSource: "",
        valueTime: [],
        eventType: "",
        state: ""
      },
      actionsOne: [],
      form: {
        startTime: '',
        endTime: '',
        buildingId: '',
        buildingName: '',
        pointLevelId: '',
        isManualAudit: '',
        hasRecordFlag: '',
        manualAuditState: '',
        aiAuditState: '',
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "buildingName",
            label: "建筑物名称"
          },
          {
            prop: "responsiblePerson",
            label: "责任人",
          },
          {
            prop: "responsibleCommunity",
            label: "所属社区",
          },
          {
            slot: "createTime",
            label: "打卡周期",
            width: "200px",
          },
          {
            slot: "rangeHourTime",
            label: "管理员审核/社区审核/打卡次数"
          },
          {
            slot: "isManualAudit",
            label: "是否人工审核"
          },
          {
            slot: "zhinshibie",
            label: "智能识别结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "submitFlag",
            label: "人工审核结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "operation",
            label: "操作",
            width: "200px"
          }
        ]
      },
      exportLoading: false,
      // 是否人工审核
      shenheList: [
        {
          value: true,
          text: '是'
        },
        {
          value: false,
          text: '否'
        }
      ],
      // 人工审核状态
      rgshList: [
        {
          value: '审核通过',
          text: "审核通过"
        },
        {
          value: '审核不通过',
          text: "审核不通过"
        },
        {
          value: '待审核',
          text: "待审核"
        }
      ],
      // AI审核状态
      znsbList: [
        {
          value: '通过',
          text: "通过"
        },
        {
          value: '不通过',
          text: "不通过"
        }
      ],
      // 审核/详情
      dialogType: "",
      shanghuCount: {
        buildingCount: 0,
        reportBuildingCount: 0,
        notReportBuildingCount: 0
      },

      value1: [],
      selectedMonth: '', // 选中的年月（格式：yyyy-MM）
      monthWeeks: [], // 该月份的所有周（[{start: 'yyyy-MM-dd', end: 'yyyy-MM-dd'}, ...]）
      selectedWeek: '' // 选中的周信息
    };
  },
  mounted() {
    this.defaultTime();
    this.getmySqDept();
  },
  methods: {
    defaultTime () {
      this.selectedMonth = `${new Date().getFullYear()}-${new Date().getMonth()+1}`;
      this.calcMonthWeeks();
    },

    calcMonthWeeks() {
      if (!this.selectedMonth) {
        this.monthWeeks = [];
        return;
      }

      // 解析年月（JS月份从0开始）
      const [year, month] = this.selectedMonth.split('-').map(Number);
      const targetMonth = month - 1;
      const targetMonthNum = month; // 当前月的数字（如1月是1）

      // 该月第一天和最后一天
      const firstDay = new Date(year, targetMonth, 1);
      const lastDay = new Date(year, targetMonth + 1, 0);

      // 找到该月第一周的周一
      let currentMonday = new Date(firstDay);
      const firstDayWeek = firstDay.getDay();
      if (firstDayWeek !== 1) {
        const diffDays = firstDayWeek === 0 ? 6 : firstDayWeek - 1;
        currentMonday.setDate(firstDay.getDate() - diffDays);
      }

      this.monthWeeks = [];
      while (currentMonday <= lastDay) {
        // 计算当周周日
        const currentSunday = new Date(currentMonday);
        currentSunday.setDate(currentMonday.getDate() + 6);

        // 格式化日期
        const formatDate = (date) => {
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        };

        // 过滤条件：周的「周一或周日」至少有1天在当前月
        const isWeekInTargetMonth = (
          (currentMonday.getMonth() + 1) === targetMonthNum ||
          (currentSunday.getMonth() + 1) === targetMonthNum
        );
        if (isWeekInTargetMonth) {
          this.monthWeeks.push({
            start: formatDate(currentMonday),
            end: formatDate(currentSunday)
          });
        }

        // 下一周周一
        currentMonday.setDate(currentMonday.getDate() + 7);
      }
      // 输出数据
        console.log(this.monthWeeks)
        if (this.monthWeeks && this.monthWeeks.length) {
          let today = `${new Date().getFullYear()}-${new Date().getMonth()+1}-${new Date().getDate()}`
          console.log(today)
          this.monthWeeks.forEach((item, index) => {
            if (new Date(today).getTime() >= new Date(item.start).getTime() && new Date(today).getTime() <= new Date(item.end).getTime()) {
              this.selectedWeek = index;
              this.handleWeekSelect(index);
            }
          })
        }
    },

    handleWeekSelect(week) {
      console.log('选中周：', week);
      this.form.startTime = `${this.monthWeeks[week].start} 00:00:00`;
      this.form.endTime = `${this.monthWeeks[week].end} 23:59:59`;
    },
    
    // 社区数据
    async getmySqDept () {
      let res = await getCommcommunityAll();
      if (res.data.code == 200) {
        let actionsData = res.data.data.map((item) => ({
          value: item.id,
          text: item.pointName,
          deptCode: item.deptCode,
        }));
        let depcode = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).detpCode;
        // let depcode = "4403260050232323";
        if (depcode.length < 12) {
          this.actionsOne = JSON.parse(JSON.stringify(actionsData));
        } else {
          let code = depcode.slice(0, 12);
          this.actionsOne = actionsData.filter(
            (item) => item.deptCode == code
          );
          if (this.actionsOne.length) {
            this.form.pointLevelId = this.actionsOne[0].value;
          }
          else {
            this.actionsOne = JSON.parse(JSON.stringify(actionsData));
          }
        }
        this.getPointTypeListPageFun();
        this.getShanghuCount();
      }
    },
    closeDetail () {
      this.dialogTableVisible = false;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    // 人工审核
    manualReview(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "审核";
      // this.currentItem.fileJson = [
      //   {
      //     url:
      //       "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
      //   },
      //   {
      //     url:
      //       "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
      //   }
      // ];
    },
    // 详情
    qusetionDetail(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "详情";
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    onReset() {
      this.form = this.$options.data().form;
      this.selectedMonth = '';
      this.selectedWeek = '';
      this.page.page = 1;
      this.page.size = 10;
      this.defaultTime();
      // this.getPointTypeListPageFun();
      // this.getShanghuCount();
      this.getmySqDept();
    },
    // 导出
    async dutyWordExp() {
      this.exportLoading = true;
      let res = await exportReportInfo({
        ...this.form,
        page: this.page.page,
        size: this.page.size
      });
      if (res.status == 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "堆物堆料打卡列表" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
      this.exportLoading = false;
    },
    // 分页查询
    async getPointTypeListPageFun() {
      console.log(this.form)
      console.log(this.form.pointLevelId)
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await recordPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },

    // 查询商户提交情况（后台列表统计）
    async getShanghuCount() {
      // if (!this.form.startTime || !this.form.endTime) return false;
      let params = {
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        pointLevelId: this.form.pointLevelId
      };
      const res = await reportInfoCount(params);
      if (res.data.code == 200) {
        this.shanghuCount = res.data.data;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
/deep/ .yearMonth {
  .el-input {
    width: 100px !important;
  }
}
/deep/ .monthWeek  {
  .el-input {
    width: 300px !important;
  }
}

.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/dwdlClockList/index.vue